export enum PrivilegesEnum {
    NONE = 0,
    VIEW= 2,
    EDIT = 1,
}